var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"clearable":"","label":"E-Store","placeholder":"Optional","data-cy":"ecommerce-select","menu-props":"offsetY","value":_vm.store,"items":_vm.stores},on:{"change":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }